import { ROOT_URL, request } from './factory/Siprec'

export default {
  getList () {
    return request(
      {
        method: 'GET',
        url: `${ROOT_URL}/filesystem/status`
      })
      .then(result => result.data.fileSystems)
  },

  /**
   * @param {number} id recording id
   * @param {'download'|'play'} operation
   * @param {(loaded: number, total: number) => void} progressCallback
   * @returns {Promise<ArrayBuffer>}
   */
  getRecording (id, operation, progressCallback) {
    if (operation !== 'play' && operation !== 'download') {
      throw new Error('Operation must be play or download')
    }

    return request(
      {
        method: 'GET',
        url: `${ROOT_URL}/filesystem/recording/${id}/${operation}`,
        responseType: 'arraybuffer',
        onDownloadProgress (e) {
          progressCallback && progressCallback(e.loaded, e.total)
        }
      }).then(response => response.data)
  },

  archiveRecording (id) {
    return request({
      method: 'GET',
      url: `${ROOT_URL}/filesystem/recording/${id}/delete`
    })
  },

  archiveRecordings (ids) {
    return request({
      method: 'POST',
      url: `${ROOT_URL}/filesystem/recording/delete`,
      data: {
        ids
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/models/FileSystem.js